// Full searchable radio details from the supplied 2023 statewide channel plan.
export default String.raw`27.1|151.19000|146.2|159.22500|000.0|H|N|
27.2|155.90250|186.2|159.27750|000.0|H|N|
27.3|154.76250|123.0|159.18000|000.0|H|N|XAM NEW
27.4|171.52500|156.7|162.75000|000.0|H|N|
27.5|151.16000|192.8|151.16000|192.8|L|N|
27.6|151.25000|192.8|151.25000|192.8|L|N|
27.7|151.37000|192.8|151.37000|192.8|L|N|
27.8|151.38500|192.8|151.38500|192.8|L|N|
27.9|154.28000|156.7|154.28000|156.7|H|N|
27.10|154.26500|156.7|154.26500|156.7|L|N|USED FOR LG CALLS
27.11|154.29500|156.7|154.29500|156.7|L|N|USED FOR LG CALLS
27.12|154.27250|156.7|154.27250|156.7|L|N|USED FOR LG CALLS
27.13|154.28750|156.7|154.28750|156.7|L|N|USED FOR LG CALLS
27.14|154.30250|156.7|154.30250|156.7|L|N|USED FOR LG CALLS
27.15|154.43000|192.8|154.43000|192.8|H|N|
27.16|154.99500|192.8|154.99500|192.8|H|N|
27.17|154.25000|192.8|154.25000|192.8|H|N|
27.18|151.32500|131.8|159.36000|000.0|H|N|
27.19|152.81000|131.8|158.07000|000.0|H|N|CALFIRE PLACER CMD
27.20|154.35500|107.2|158.89500|000.0|H|N|PLACER FIRE DISP W
27.21|151.17500|136.5|159.45000|000.0|H|N|
27.22|151.35500|103.5|159.30000|000.0|H|N|
27.23|151.26500|103.5|159.33000|000.0|H|N|
27.24|151.22000|192.8|151.22000|192.8|L|N|CDF Air to Ground #1
27.25|159.26250|192.8|159.26250|192.8|L|N|CDF Air to Ground #2
27.26|159.36750|192.8|159.36750|192.8|L|N|
27.27|167.50000|000.0|167.50000|000.0|L|N|IA Air/Ground Primary CAO2
27.28|169.11250|000.0|169.11250|000.0|L|N|IA A/G Secondary CAO2 &CAO4
27.29|172.32500|156.7|165.22500|000.0|H|N|ENF ADMIN NET
27.30|173.76250|156.7|164.82500|000.0|H|N|ENF SERVICE-After 6/19/17
27.31|168.66250|000.0|168.66250|000.0|H|N|ENF PROJECT NET
27.32|166.55000|000.0|166.55000|000.0|L|N|R5 TAC 4
27.33|167.11250|000.0|167.11250|000.0|L|N|R5 TAC 5
27.34|168.23750|000.0|168.23750|000.0|L|N|R5 TAC 6
27.35|168.20000|000.0|168.20000|000.0|L|N|NIFC TAC 2
27.36|172.37500|156.7|164.96250|000.0|H|N|Lake Tahoe MU Basin
27.37|171.57500|156.7|165.41250|000.0|H|N|Tahoe Basin MU Admn Net
27.38|153.95000|100.0|154.44500|000.0|H|N|Use Tone 9
27.39|153.99500|162.2|155.94000|000.0|H|N|SLT OPS TONE 12
27.40|154.34000|100.0|153.89000|000.0|H|N|LAKE VALLEY NET
27.41|155.36250|100.0|159.08250|000.0|H|N|NEW LV CHANNEL TONE 9
27.42|154.13000|131.8|159.49500|000.0|H|N|
27.43|154.23500|000.0|154.23500|000.0|H|N|INCLINE VILLAGE
27.44|154.40000|94.8|153.77000|000.0|H|N|OLD TAHOE CITY
27.45|155.02500|151.4|158.77500|167.9|H|N|MEEKS BAY REPEATER SITE
27.46|154.38500|000.0|154.38500|000.0|L|N|
27.47|158.89500|000.0|156.07500|000.0|H|N|
27.48|173.77500|000.0|165.75000|000.0|H|N|USFS TOIYABE NF
27.49|153.80000|000.0|154.10000|000.0|H|N|Alpine SO & Fire
27.50|151.23500|000.0|155.7750|000.0|H|N|EAST FORK FIRE
27.51|158.74500|000.0|159.39000|000.0|H|N|Truckee Meadows Main (Reno)
27.52|171.67500|000.0|171.67500|000.0|H|N|BLM Scene of action
27.53|169.98750|136.5|162.23750|000.0|H|N|BLM Carson City Dist.
27.54|159.34500|000.0|159.34500|000.0|L|N|NDF TAC
27.55|158.86500|000.0|158.86500|000.0|L|N|NDF TAC
27.56|159.37500|000.0|159.37500|000.0|L|N|NDF TAC
27.57|159.27000|000.0|159.27000|000.0|L|N|NDF TAC
27.58|166.87500|000.0|166.87500|000.0|L|N|FED A/G MINDEN
27.59|168.31250|000.0|168.31250|000.0|L|N|FED A/G MINDEN
27.60|168.48750|000.0|168.48750|000.0|L|N|FED A/G MINDEN
27.61|153.93500|123.0|158.88000|000.0|H|N|OLD XAM COMMAND
27.62|155.50500|000.0|155.50500|000.0|H|N|
27.63|153.75500|000.0|154.98000|000.0|H|N|CA TRAVEL NET
27.64|156.07500|156.7|156.07500|156.7|H|N|
27.65|159.55500|136.5|000.00000|000.0||N|RX ONLY for non-LE load
27.66|159.69000|136.5|000.00000|000.0||N|RX ONLY for non-LE load
27.67|159.69000|146.2|000.00000|000.0||N|RX ONLY for non-LE load
27.68|159.60000|136.5|000.00000|000.0||N|RX ONLY for non-LE load
27.69|154.96500|167.9|000.00000|000.0||N|RX ONLY for non-LE load
27.70|159.10500|167.9|000.00000|000.0||N|RX ONLY for non-LE load
27.71|154.78500|173.8|000.00000|000.0||N|RX ONLY for non-LE load
27.72|154.74000|167.9|000.00000|000.0||N|RX ONLY for non-LE load
27.73|153.80000|107.2|000.00000|000.0||N|RX ONLY for non-LE load
27.74|168.62500|000.0|168.62500|110.9|L|N|Emergency
28.1|136.0000|0.0|136.0000|.0.0|H|N|
29.1|172.3750|CSQ|164.9375|OST|H|N|
29.2|152.5400|151.4|157.8000|151.4|H|N|
29.3|152.5700|151.4|157.8300|151.4|H|N|
29.4|152.7800|151.4|158.0400|151.4|H|N|
29.5|159.1800|100.0|155.5200|100.0|H|N|(Mt. Lee) LA Regional Tac Comms Sys
29.6|168.2000|CSQ|168.2000|000.0|L|N|
29.7|154.2650|156.7|154.2650|156.7|L|N|
29.8|154.2950|156.7|154.2950|156.7|L|N|
29.9|154.2725|156.7|154.2725|156.7|L|N|
29.10|154.2875|156.7|154.2875|156.7|L|N|
29.11|154.3025|156.7|154.3025|156.7|L|N|
29.12|169.1125|CSQ|169.1125|000.0|H|N|
29.13|154.4000|151.4|154.4000|151.4|H|N|
29.14|154.8300|100.0|154.8300|100.0|H|N|
29.15|156.3300|156.7|156.3300|156.7|H|N|
29.16|168.6250|CSQ|168.6250|110.9|L|N|Emergency
30.1|152.1500|151.4|158.6100|151.4|H|N|
30.2|152.2400|151.4|158.7000|151.4|H|N|
30.3|152.5400|151.4|157.8000|151.4|H|N|
30.4|152.5700|151.4|157.8300|151.4|H|N|
30.5|152.7800|151.4|158.0400|151.4|H|N|
30.6|154.3250|79.7|155.8350|79.7|H|N|
30.7|155.9850|186.2|154.7250|186.2|H|N|
30.8|154.2650|156.7|154.2650|156.7|L|N|
30.9|154.2950|156.7|154.2950|156.7|L|N|
30.10|154.2725|156.7|154.2725|156.7|L|N|
30.11|154.2875|156.7|154.2875|156.7|L|N|
30.12|154.3025|156.7|154.3025|156.7|L|N|
30.13|154.4000|151.4|154.4000|151.4|H|N|
30.14|154.8300|100.0|154.8300|100.0|H|N|
30.15|154.2350|167.9|154.2350|167.9|H|N|
30.16|168.6250|CSQ|168.6250|110.9|L|N|Emergency`;
